import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import IgdFilters from './Filters/IgdFilters';
import PeriodIndicator from '../../Common/Filters/PeriodIndicator';
import { Modal } from '@mui/material';
import { Buttons } from './Buttons';
import CityFilter from './CityFilter';
import { AvailablePeriodProvider } from '../../Common/contexts/AvailablePeriodContext';
import { useIgdFiltersContext } from './Filters/hooks/useIgdFiltersContext';

const IgdChartsContainer = ({ title, className, children }) => {
    const { filters } = useIgdFiltersContext();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [isCityFilterOpen, setIsCityFilterOpen] = useState(false);

    return (
        <AvailablePeriodProvider key={location.pathname}>
            <div className={`${className}`}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px'
                    }}
                >
                    <h2 className="title-dashboards">{title}</h2>
                    <Buttons
                        onClickFilters={() => setOpen(true)}
                        onClickCityFilter={() => setIsCityFilterOpen(true)}
                    />
                    <Modal open={open} onClose={() => setOpen(false)}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '10%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                                backgroundColor: '#fff',
                                padding: '24px',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                maxWidth: '90vw',
                                width: '80%'
                            }}
                        >
                            <IgdFilters />
                        </div>
                    </Modal>
                    <Modal
                        open={isCityFilterOpen}
                        onClose={() => setIsCityFilterOpen(false)}
                    >
                        <div
                            style={{
                                position: 'absolute',
                                top: '10%',
                                left: '50%',
                                transform: 'translate(-50%, 0)',
                                backgroundColor: '#fff',
                                padding: '24px',
                                borderRadius: '8px',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                                maxWidth: '90vw',
                                width: '80%'
                            }}
                        >
                            <CityFilter />
                        </div>
                    </Modal>
                </div>

                <PeriodIndicator filters={filters} />

                <div className="charts-container-dashboards">{children}</div>
            </div>
        </AvailablePeriodProvider>
    );
};

export default IgdChartsContainer;
